/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { styled } from '@mui/material';

type ActionsBarProps = {
    children?: React.ReactNode;
};

const ActionsBarRoot = styled("div")(({ theme }) => ({
    paddingInlineEnd: "34.39px", // korrigiert die falsche Ausrichtung verursacht durch den leeren Tooltip
    display: "flex",
    "& > *:not(:first-child), & > *:first-child:last-child": {
        marginLeft: "auto",
    },
    paddingBlockStart: theme.spacing(),
}));

export default function ActionsBar(props: ActionsBarProps) {
    return (
        <ActionsBarRoot>
            {props.children}
        </ActionsBarRoot>
    );
}